<template>
  <div @touchmove.prevent class="mask-container" v-if="isShow">
    <img class="content" :src="contentImg" alt="" />
    <img
      @click="closeMask"
      class="close-icon"
      src="../assets/imgs/exchange_pay_close.png"
      alt=""
    />
  </div>
</template>

<script>
export default {
  props: {
    contentImg:{
      type: String,
      default: "",
    },
    isShow:{
        type:Boolean,
        default:true
    }
  },
  methods:{
      closeMask(){
          this.$emit('update:isShow',false)
      }
  }
};
</script>

<style lang="scss" scoped>
.mask-container {
 position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
//   width: 100vw;
//   height: 100vh;
  filter: alpha(opacity=100);
  opacity: 1;
  display: block;
  z-index: 999;
  .content {
    display: block;
    width: 80%;
    margin: 70px auto 20px;
  }
  .close-icon {
    display: block;
    width: 30px;
    height: 30px;
    margin: 0 auto;
  }
}
</style>